module.exports = __webpack_public_path__ + "media/tsemppiaani3.d1dd868c.wav";